import React, { useState, useEffect } from "react";
import {
  Link,
  useParams,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

function EmailAuditDetail() {
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [templateName, setTemplateName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage] = useState(10);

  const { emailId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (emailId) {
      const page = parseInt(searchParams.get("page")) || 1;
      setCurrentPage(page);
      fetchAuditLogs(page);
    }
  }, [emailId, searchParams]);

  const fetchAuditLogs = async (page = 1) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");

      const response = await fetch(
        `${apiUrl}fetch-email-logs/${emailId}?page=${page}&limit=${itemsPerPage}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch audit logs");
      }

      const result = await response.json();
      setAuditLogs(result.data.logs);

      if (result.data.logs.length > 0 && !templateName) {
        setTemplateName(result.data.logs[0].templateName);
      }

      if (result.data.totalCount) {
        setTotalPages(Math.ceil(result.data.totalCount / itemsPerPage));
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    navigate(`?page=${newPage}`);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const renderPagination = () => {
    return (
      <div className="d-flex justify-content-between align-items-center mt-4">
        <button
          className="btn btn-outline-secondary px-4 rounded"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <div className="text-center">
          Page {currentPage} of {totalPages}
        </div>

        <button
          className="btn btn-outline-secondary px-4 rounded"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  if (loading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  if (error) {
    return (
      <div className="alert alert-danger m-4" role="alert">
        {error}
      </div>
    );
  }

  return (
    <>
      <div className="dashboard-title mb-3">
        <h4 className="d-flex align-items-center">
          <Link
            to="/view-email-audit"
            className="btn btn-outline-secondary btn-sm me-3"
          >
            <i className="bi bi-arrow-left"></i>
          </Link>
          {templateName} Audit Detail
        </h4>
      </div>
      <div className="row mb-3">
        <div className="col-12 col-xl-12">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Name</th>
                  <th scope="col">Timestamp</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {auditLogs.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No audit logs found
                    </td>
                  </tr>
                ) : (
                  auditLogs.map((log, index) => (
                    <tr key={log._id}>
                      <th scope="row">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </th>
                      <td>{log.userName}</td>
                      <td>{formatDate(log.createdAt)}</td>
                      <td>{log.action}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {auditLogs.length > 0 && renderPagination()}
          </div>
        </div>
      </div>
    </>
  );
}

export default EmailAuditDetail;
